export default class Slider {
	constructor( $node ) 
	{
		if( $node.querySelectorAll('.carousel-item').length <= 1 )
		{	
			return; 
		}

		this.$node  = $node
		this.$wrap  = $node.querySelector('.carousel-wrapper')

		this._initializeNavigation()

		if ( typeof this.$node.dataset.interval != 'undefined' && this.$node.dataset.interval )
		{
			this._initAutoSlide()
		}
	}

	/**
	 * Initialize an auto slider
	 * 
	 */
	_initAutoSlide()
	{
		let hoverstate = false 
		let interval   = setInterval( 
			function(){ !hoverstate && this.slideNext() }.bind( this ), 
			this.$node.dataset.interval * 1000  
		)
		
		Array.from( this.$node.querySelectorAll('.slide-nav .slide-arrow') ).forEach(node => {
			node.addEventListener('mouseenter', () => { hoverstate = true })
			node.addEventListener('mouseleave', () => { hoverstate = false })
			node.addEventListener('click', () => { clearInterval( interval ) })
		})

		// Set min height ( why do we do this? )
		var height = 0

		Array.from( this.$node.querySelectorAll('.carousel-item') ).forEach(function(node) {
			height = Math.max( height, node.offsetHeight )
		})

		if ( height ) 
		{
			this.$node.querySelector('.carousel-wrapper').style.minHeight = height + 'px'
		}
	}

	/**
	 * Initialize the navigation
	 * 
	 * @access 	private
	 */
	_initializeNavigation() 
	{
		var $wrap = document.createElement('div')
			$wrap.classList.add('slide-nav')
			$wrap.classList.add('nav-arrow')
		
		var $prev = document.createElement('div')
			$prev.classList.add('slide-arrow')
			$prev.classList.add('slide-prev')
			$prev.classList.add('active')
			$prev.addEventListener('click', this.slidePrev.bind( this ) )

		$wrap.append( $prev )

		var $next = document.createElement('div')
			$next.classList.add('slide-arrow')
			$next.classList.add('slide-next')
			$next.classList.add('active')
			$next.addEventListener('click', this.slideNext.bind( this ) )

		$wrap.append( $next )

		this.$node.append( $wrap )

		return this
	}

	/**
	 * Return the number of the current slide
	 * 
	 * @return	int
	 */
	_getSlideNumber()
	{
		var count = 0;
		var $slide = this.$node.querySelector('.carousel-item.active')

		while ( $slide.previousSibling ) 
		{
			$slide = $slide.previousSibling

			if ( $slide.tagName == 'DIV' ) 
			{
				count++
			}
		}

		return count
	}

	/**
	 * Slide to the previous slide
	 * 
	 * @return 	Carousel
	 */
	slidePrev()
	{
		return this.slideTo( this._getSlideNumber() - 1 )
	}

	/**
	 * Slide to the next slide
	 * 
	 * @return 	Carousel
	 */
	slideNext()
	{
		return this.slideTo( this._getSlideNumber() + 1 )
	}

	/**
	 * Slide to a specific slide
	 * 
	 * @param 	int The $slide to slide to
	 * @return	Carousel
	 */
	slideTo ( $slide )
	{	
		var $active = this.$node.querySelector('.carousel-item.active')

		if ( $active ) 
		{
			$active.classList.remove('active')
		}
		
		// Convert slide to element
		if( Number.isInteger( $slide ) )
		{
			var list   = Array.from( this.$node.getElementsByClassName('carousel-item') )
				$slide = $slide > list.length ? 0 : $slide
				$slide = $slide < 0 ? list.length - 1 : $slide

				$slide = typeof list[ $slide ] != 'undefined' ? list[ $slide ] : list[ 0 ] 
		}
		
		$slide.classList.add('active')
	}
}